'use client';

import {
	Box, useSlotRecipe, Text, Grid as ChakraGrid,
	GridItem,
} from '@chakra-ui/react';
import type {
	BoxProps, GridProps, TextProps,
} from '@chakra-ui/react';
import React from 'react';
import type { PropsWithChildren } from 'react';

const Content = ({ children, ...boxProps }: PropsWithChildren<BoxProps>) => {
	const recipe = useSlotRecipe({ key: 'dataDisplay' });
	const styles = recipe();

	return (
		<Box css={styles.content} {...boxProps}>
			{children}
		</Box>
	);
};

const DisplayGrid = ({ children, ...gridProps }: PropsWithChildren<GridProps>) => {
	return (
		<ChakraGrid {...gridProps}>
			{children}
		</ChakraGrid>
	);
};

const Header = ({ children, ...textProps }: PropsWithChildren<TextProps>) => {
	const recipe = useSlotRecipe({ key: 'dataDisplay' });
	const styles = recipe();

	return (
		<Text css={styles.header} {...textProps}>
			{children}
		</Text>
	);
};

const Root = ({ children, ...boxProps }: PropsWithChildren<BoxProps>) => {
	const recipe = useSlotRecipe({ key: 'dataDisplay' });
	const styles = recipe();

	return (
		<Box css={styles.root} {...boxProps}>
			{children}
		</Box>
	);
};

const DisplayGridItem = ({ children }: PropsWithChildren) => {
	const recipe = useSlotRecipe({ key: 'dataDisplay' });
	const styles = recipe();

	return (
		<GridItem css={styles.gridItem} whiteSpace="pre-wrap">
			{children}
		</GridItem>
	);
};

const Footer = ({ children, ...boxProps }: PropsWithChildren<BoxProps>) => {
	return (
		<Box bg="gray.10" p={4} {...boxProps}>
			{children}
		</Box>
	);
};

export const Display = {
	Content:  Content,
	Footer:   Footer,
	Grid:     DisplayGrid,
	GridItem: DisplayGridItem,
	Header:   Header,
	Root:     Root,
};
